/**
 * aaa-cwd-customiser  (re-synced 2026-06-09)
 * ---------------------------------------------------------------------------
 * "Sport Color" customiser control for CWD saddles. Renders in the product
 * Details column. It does NOT show an image itself — it drives the left media
 * gallery (aaa-cwd-media-gallery) by dispatching a 'cwd:customisation' event,
 * and writes the chosen customisation as a line-item property so it travels
 * into the cart/order.
 *
 * Swatches are server-rendered with data-cust-id / data-name, so this island
 * needs no config JSON — it just tracks selection, writes the property, updates
 * the label, and emits the event. Dependency-free (F.9).
 */
(function () {
  var CUSTOMISATION = 'cwd:customisation';

  if (customElements.get('aaa-cwd-customiser')) return;

  class CwdCustomiser extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      this.nameLabel = this.querySelector('[data-cwd-selected-name]');
      this.input = this.querySelector('[data-cwd-property-input]');
      this.swatches = Array.prototype.slice.call(this.querySelectorAll('[data-cust-id]'));
      if (!this.swatches.length) return;

      this.swatches.forEach((btn) => {
        btn.addEventListener('click', () => {
          this._select(btn.getAttribute('data-cust-id'), btn.getAttribute('data-name'), false);
        });
        btn.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this._select(btn.getAttribute('data-cust-id'), btn.getAttribute('data-name'), false);
          }
        });
      });

      // Reflect the default selection without emitting an event — the gallery
      // server-renders the same default, so initial state is already in sync
      // and we avoid a load-order race between the two islands.
      var want = this.getAttribute('data-default-cust');
      var def = this.swatches.filter((b) => b.getAttribute('data-cust-id') === String(want))[0] || this.swatches[0];
      this._select(def.getAttribute('data-cust-id'), def.getAttribute('data-name'), true);

      this._initPreview();
    }

    // Mobile selection preview: mirrors the gallery's main image so the
    // customer sees their swatch tap take effect without scrolling back up
    // (on phones the gallery is several screens above this block). The
    // gallery owns all image-resolution logic; we just reflect its <img>
    // src/alt via a MutationObserver. Same-src means the image comes
    // straight from cache - no extra download. Tapping the preview scrolls
    // to the gallery. CSS hides the preview at >=750px.
    _initPreview() {
      this.preview = this.querySelector('[data-cwd-preview]');
      if (!this.preview) return;
      this.previewImg = this.querySelector('[data-cwd-preview-img]');
      var galleryImg = document.querySelector('[data-cwd-gallery-main]');
      if (!galleryImg || !this.previewImg) return;

      var sync = () => {
        var src = galleryImg.getAttribute('src');
        if (!src) return;
        this.previewImg.setAttribute('src', src);
        this.previewImg.setAttribute('alt', galleryImg.getAttribute('alt') || '');
        this.preview.hidden = false;
      };
      sync();
      this._previewObserver = new MutationObserver(sync);
      this._previewObserver.observe(galleryImg, { attributes: true, attributeFilter: ['src', 'alt'] });

      this.preview.addEventListener('click', () => {
        var gallery = galleryImg.closest('aaa-cwd-media-gallery') || galleryImg;
        gallery.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    disconnectedCallback() {
      if (this._previewObserver) this._previewObserver.disconnect();
    }

    _select(custId, name, silent) {
      this.currentCust = String(custId);
      this.swatches.forEach((b) => {
        var on = b.getAttribute('data-cust-id') === this.currentCust;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.classList.toggle('is-selected', on);
      });
      if (this.nameLabel) this.nameLabel.textContent = name || '';
      if (this.input) this.input.value = name || '';
      if (!silent) {
        document.dispatchEvent(
          new CustomEvent(CUSTOMISATION, { bubbles: true, detail: { custId: this.currentCust, name: name } })
        );
      }
    }
  }

  customElements.define('aaa-cwd-customiser', CwdCustomiser);
})();
